import React, { FC } from 'react'
import { getItemOrFirstEntry } from '@/utils/array-utils'
import { useSafeRouter } from '@/utils/nextUtils/safe-router'
import { useGiveawayContext } from '../../context/GiveawayContext'
import { OverlayYoutubeVideo } from './OverlayYouTubeVideo'
import { ShareGiveawayModal } from './ShareGiveawayModal'

export const GiveawayModals: FC = () => {
  const {
    isScenePlayerOpen,
    setIsScenePlayerOpen,
    togglePauseBackgroundVideo,
    isShareModalOpen,
    setIsShareModalOpen,
    giveawayData,
    sweepstake,
  } = useGiveawayContext()

  const { query } = useSafeRouter()
  const sceneId = getItemOrFirstEntry(query?.sceneId)
  const { share } = giveawayData
  const { rulesUrl } = sweepstake

  return (
    <>
      {sceneId && (
        <OverlayYoutubeVideo
          isOpen={isScenePlayerOpen}
          onClose={() => {
            setIsScenePlayerOpen(false)
            togglePauseBackgroundVideo() // Remove the argument
          }}
          youtubeID={sceneId}
        />
      )}

      {share && (
        <ShareGiveawayModal
          isOpen={isShareModalOpen}
          onClose={() => setIsShareModalOpen(false)}
          imageUrl={share.shareImage}
          imageUrlMobile={share.shareImageMobile}
          shareText={share.shareText}
          rulesLink={rulesUrl}
        />
      )}
    </>
  )
}
